import { render, staticRenderFns } from "./PurchaseOrderTemplate.vue?vue&type=template&id=58c216be"
import script from "./PurchaseOrderTemplate.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c216be')) {
      api.createRecord('58c216be', component.options)
    } else {
      api.reload('58c216be', component.options)
    }
    module.hot.accept("./PurchaseOrderTemplate.vue?vue&type=template&id=58c216be", function () {
      api.rerender('58c216be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/PurchaseOrderTemplate.vue"
export default component.exports